import React, {ReactNode, useEffect} from 'react';
import {View} from 'react-native';

import {Login} from '/component/screen/Login';
import {withStatusBar} from '/provider/StatusBarProvider';

import {styles} from './LoginProvider.style';
interface LoginProviderProps {
  statusBarSetDarkText: () => void;
  statusBarSetWhiteBackground: () => void;
  isSignedIn: boolean;
  children: ReactNode;
}

export class LoginProvider extends React.PureComponent<LoginProviderProps> {
  static defaultProps: Partial<LoginProviderProps> = {
    statusBarSetDarkText: () => {},
    statusBarSetWhiteBackground: () => {},
    isSignedIn: false,
    children: null,
  };

  getLoginViewComponent() {
    const {statusBarSetDarkText, statusBarSetWhiteBackground} = this.props;

    return () => {
      // Update status bar text style with effect because that's how status bar text style
      // is updated everywhere else as well. This way we can avoid issues caused by difference
      // in timing between effects and lifecycle methods.
      useEffect(() => {
        statusBarSetDarkText();
        statusBarSetWhiteBackground();
      }, [statusBarSetDarkText, statusBarSetWhiteBackground]);

      return (
        <View style={styles.loginView}>
          <Login currentScreen="loginScreen" />
        </View>
      );
    };
  }

  getChildrenViewComponent() {
    const {children} = this.props;

    return () => {
      // No need to update StatusBar here because this content is not a leaf-level screen.

      return children;
    };
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  render() {
    const {isSignedIn} = this.props;

    const LoginView = this.getLoginViewComponent();
    const ChildrenView = this.getChildrenViewComponent();

    return isSignedIn ? <ChildrenView /> : <LoginView />;
  }
}

export default withStatusBar(LoginProvider);
